<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" id="projectTitle">Comentários</h5>
    <button type="button" class="close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col">
        <button class="btn btn-primary" (click)="showForm()" [hidden]="hideTable">ADICIONAR</button>
      </div>
    </div><br>

    <div class="row">
      <div class="col">
        <form [formGroup]="commentsForm" [hidden]="hideForm">
          <div class="form-group">
            <label for="message">Mensagem *</label>
            <textarea formControlName="message" class="form-control" id="message"
              [ngClass]="{ 'is-invalid': submitted && commentsForm.get('message').hasError('required') }"
            >
            </textarea>
            <small class="invalid-feedback" *ngIf="submitted && commentsForm.get('message').hasError('required')">
              Mensagem não foi informada
            </small>
          </div>
          <div class="modal-footer">
            <button (click)="cancel()" type="button" class="btn btn-link">
              Voltar
            </button>
            <button type="button" (click)="save()" [attr.data-loader]="!submitted" btnloader
              class="btn btn-primary mainBackground-color mr-2">
              Salvar
            </button>
          </div>
        </form>

        <table class="table table-sm table-bordered" [hidden]="hideTable">
          <thead class="thead-light">
            <tr>
              <th class="th-table text-center" scope="col">Mensagem</th>
              <th class="th-table text-center" scope="col">Resolvido</th>
              <th class="text-center" scope="col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="loading">
              <td colspan="3">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border text-info" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="!loading && !comments.length">
              <td colspan="3">
                <p class="text-muted">Nenhum registro encontrado.</p>
              </td>
            </tr>
            <tr *ngFor="let comment of comments">
              <td class="text-center">
                {{ comment.message }}
              </td>
              <td class="text-center">
                <div #spinnerCheck class="spinner-border spinner-border-sm" role="status" style="display: none;">
                  <span class="sr-only">Loading...</span>
                </div>
                <span #checkIcon>
                  <strong *ngIf="comment.resolved">SIM</strong>
                  <strong *ngIf="!comment.resolved">NÃO</strong>
                </span>
              </td>
              <td class="text-center">
                <div class="btn-group btn-group-sm" role="group" aria-label="Ações">
                  <button *ngIf="!comment.resolved" type="button" class="btn btn-link" (click)="solveComment(spinnerCheck, checkIcon, comment)">
                    <i class="fas fa-check"></i> Resolver
                  </button>
                  <button *ngIf="!comment.resolved" type="button" class="btn btn-link" (click)="edit(comment)">
                    <i class="fas fa-edit pointer"></i>
                  </button>
                  <button type="button" class="btn btn-link" (click)="delete(comment)">
                    <i class="fas fa-trash pointer"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
